import {
    Shirt,
    Watch,
    Home,
    Coffee,
    Palette,
    Sparkles,
    Baby,
    PawPrint,
    Laptop,
    Bike,
} from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";

const ICONS = {
    Shirt, Watch, Home, Coffee, Palette, Sparkles, Baby, PawPrint, Laptop, Bike,
};

/**
 * Vitrina informativa de las categorías disponibles al crear una tienda.
 * Es deliberadamente NO interactiva: no enlaza al catálogo ni a las tiendas.
 */
export default function CategoriesGrid({ categories = [] }) {
    const reduce = useReducedMotion();
    if (!categories.length) return null;

    return (
        <section
            id="categorias"
            data-testid="home-categories"
            className="py-20 sm:py-28 lg:py-32 bg-[#F6F6F3]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mx-auto text-center">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
                        Explora por categoría
                    </p>
                    <h2 className="mt-4 text-4xl sm:text-5xl lg:text-[3.5rem] font-extrabold tracking-[-0.03em] leading-[1.02] text-[#1A1A1A] text-balance">
                        Vendas lo que vendas, aquí cabe
                    </h2>
                    <p className="mt-5 text-lg text-[#4A4A4A] leading-relaxed">
                        Elige la categoría de tu tienda al crearla. Puedes
                        cambiarla cuando quieras.
                    </p>
                </div>

                <ul className="mt-16 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4">
                    {categories.map((cat, i) => {
                        const Icon = ICONS[cat.icon] || Shirt;
                        return (
                            <motion.li
                                key={cat.id}
                                initial={reduce ? false : { opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-40px" }}
                                transition={{
                                    duration: reduce ? 0 : 0.35,
                                    delay: reduce ? 0 : Math.min(i * 0.04, 0.4),
                                    ease: "easeOut",
                                }}
                                data-testid={`category-card-${cat.slug}`}
                                className="flex items-center gap-3 p-5 rounded-2xl bg-white"
                            >
                                <div className="w-10 h-10 rounded-xl bg-[#F6F6F3] grid place-items-center shrink-0">
                                    <Icon className="w-5 h-5 text-primary" aria-hidden="true" />
                                </div>
                                <span className="text-sm font-semibold text-[#1A1A1A]">
                                    {cat.name}
                                </span>
                            </motion.li>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
}
